module.exports = __webpack_public_path__ + "img/poster8-main.fb6352b9.png";